import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Conditional from '../../common/conditional';
import Button from '../../themed/button';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import { transformListToOptions } from '../../../utils/utilities';

interface SWUTObservationItem {
    id: number;
    jointNumber: string;
    comment: string;
    result: string;
    defectLength: string | number;
    defectDepth: string | number;
    defectHeight: string | number;
}

class SWUTObservationItemForm extends Form {
	state = {
		data: {
			jointNumber: '',
            comment: '',
            result: '',
            defectLength: '',
            defectDepth: '',
            defectHeight: '',
		},
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
        id: Joi.number().optional().label('ID'),
        jointNumber: Joi.string().required().label('Joint Number'),
        comment: Joi.string().required().label('Comment'),
        result: Joi.string().required().label('Result'),
        defectLength: Joi.alternatives(Joi.string(), Joi.number().positive()).required().label('Defect Length (mm)'),
        defectDepth: Joi.alternatives(Joi.string(), Joi.number()).required().label('Defect Depth (mm)'),
        defectHeight: Joi.alternatives(Joi.string(), Joi.number()).required().label('Defect Height(mm)'),
    };

    static propTypes = {
        initialObservationItem: PropTypes.object,
        onDeleteItem: PropTypes.func,
        onSave: PropTypes.func,
    };

    componentDidMount(): void {
        if (this.props.initialObservationItem) {
            this.setState({ data: this.props.initialObservationItem });
        }
    }
	
	doSubmit = () => {
		this.props.onSave(this.state.data);

        if (!this.props.initialObservationItem) {
            this.resetData();
        }

        toastService.success('Data Saved Successfully!');
	};

    resetData = () => {
        this.setState({
            data: {
                jointNumber: '',
                comment: '',
                result: '',
                defectLength: '',
                defectDepth: '',
                defectHeight: '',
            },
        })
    };


	render() {
		return (
            <form autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="row">
                    <div className="col">
                        {this.renderInput({
                            type: 'text',
                            name: 'jointNumber',
                            label: 'Joint Number',
                            placeholder: 'Select Joint Number',
                        })}
                    </div>

                    <div className="col">
                        {this.renderTextArea({
                            name: 'comment',
                            label: 'Comment',
                            placeholder: 'Enter Comment',
                        })}
                    </div>
                    
                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(RESULT),
                            name: 'result',
                            label: 'Result',
                            placeholder: 'Select Result',
                        })}
                    </div>
                </div>

                <div className="my-4 divider"></div>
                
                <div className="row">
                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(DEFECT_LENGTHS),
                            name: 'defectLength',
                            label: 'Defect Length (mm)',
                            placeholder: 'Select Defect Length (mm)',
                        })}
                    </div>

                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(DEFECT_DEPTHS),
                            name: 'defectDepth',
                            label: 'Defect Depth (mm)',
                            placeholder: 'Select Defect Depth (mm)',
                        })}
                    </div>

                    <div className="col">
                        {this.renderSelect({
                            options: transformListToOptions(DEFECT_DEPTHS),
                            name: 'defectHeight',
                            label: 'Defect Height (mm)',
                            placeholder: 'Select Defect Height (mm)',
                        })}
                    </div>
                </div>
                
                <div className="my-4 divider"></div>

                <div className="d-flex justify-content-end">
                    <Conditional isVisible={!!this.props.onDeleteItem}>
                        <div className="me-3">
                            <Button
                                onClick={this.props.onDeleteItem} 
                                icon="trash"
                                label="Delete" 
                                type="button"
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>
                    </Conditional>

				    {this.renderButton('Save')}
                </div>
            </form>
		);
	}
}

const RESULT = ['N/A', 'Accept', 'Reject'];
const DEFECT_LENGTHS = ['N/A', ..._.range(0.5, 1001)];
const DEFECT_DEPTHS = ['N/A', ..._.range(0, 201)];

export type { SWUTObservationItem }
export default SWUTObservationItemForm;
